import { type Components } from '@mui/material'
export const Checkbox: Partial<Components> = {
  MuiCheckbox: {
    styleOverrides: {
      root: {
        color: '#D3D3D3',
        '&.Mui-checked': {
          color: '#4D5E80'
        }
      }
    }
  }
}
